import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { redirigirSegunUser } from "utils/generalFunctions";

const AdminProtectedRoutes = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  if (user?.roles[0] == "Admin" || user?.roles[0] == "Superadmin") {
    return children;
  } else {
    return redirigirSegunUser(user);
  }
};

export default AdminProtectedRoutes;
